import React, { useState } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { withTurkishStringFilters } from "shared/util/datagrid";

const List = ({ name, items, columns, onItemSelect }) => {
  const visibilityJSON = localStorage.getItem(`${name}_visibility`);
  const visibilityModel = visibilityJSON ? JSON.parse(visibilityJSON) : {};
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(visibilityModel);

  const filterJSON = localStorage.getItem(`${name}_filter`);
  const initialFilterModel = filterJSON ? JSON.parse(filterJSON) : { items: [] };
  const [filterModel, setFilterModel] = useState(initialFilterModel);

  // Need version 7
  // const [density, setDensity] = useState(localStorage.getItem(`${name}_density`) || "compact");

  const initPageSize = parseInt(localStorage.getItem(`${name}_pageSize` || 100)) || 100;
  // eslint-disable-next-line no-unused-vars
  const [pageSize, setPageSize] = useState(initPageSize);

  const OnSelectionChangeHandler = (event) => {
    onItemSelect(event[0]);
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{
          button: {
            fontSize: "14px",
            // fontWeight: "bold",
            textTransform: "none",
            // color: "var(--color-primary-surface)",
            // "&:hover": {
            //   backgroundColor: "#f0f0f0",
            // },
          },
        }}
      >
        <GridToolbarFilterButton style={{ marginRight: "20px" }} />
        <GridToolbarColumnsButton style={{ marginRight: "20px" }} />
        <GridToolbarDensitySelector style={{ marginRight: "20px" }} />
        <GridToolbarExport csvOptions={{ utf8WithBom: true }} />
      </GridToolbarContainer>
    );
  }

  return (
    <div style={{ height: "100%", flex: 1 }}>
      <DataGrid
        sx={{
          borderRadius: 0,
          fontSize: "14px", // Genel font boyutu
          ".MuiDataGrid-columnHeaders": {
            fontSize: "15px",
            fontWeight: 600,
          },
          ".MuiDataGrid-cell": {
            fontSize: "14px",
          },
          ".MuiDataGrid-row": {
            "&:hover": {
              backgroundColor: "#e0e0e0", // Hover rengi
            },
            "&.Mui-selected": {
              borderLeft: "4px solid var(--color-primary-surface)",
              backgroundColor: "#e8f0fe !important",
            },
          },
        }}
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityModelChange={(newModel) => {
          localStorage.setItem(`${name}_visibility`, JSON.stringify(newModel));
          setColumnVisibilityModel(newModel);
        }}
        filterModel={filterModel}
        onFilterModelChange={(newModel) => {
          localStorage.setItem(`${name}_filter`, JSON.stringify(newModel));
          setFilterModel(newModel);
        }}
        density="compact"
        // density={density}
        // onDensityChange={(newDensity) => {
        //   localStorage.setItem(`${name}_density`, newDensity);
        //   setDensity(newDensity);
        // }}
        //pageSize={pageSize}
        pageSize={100}
        onPageSizeChange={(newPageSize) => {
          if (!newPageSize || newPageSize < 1 || newPageSize > 100) {
            newPageSize = 100;
          }
          localStorage.setItem(`${name}_pageSize`, newPageSize);
          setPageSize(newPageSize);
        }}
        key={items}
        components={{
          Toolbar: CustomToolbar,
        }}
        rows={items}
        columns={withTurkishStringFilters(columns)}
        getRowId={(r) => r.id}
        onSelectionModelChange={OnSelectionChangeHandler}
        getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row")}
      />
    </div>
  );
};

export default List;
